export const serviceGoalMapping = {
  'Affordable Housing': 'improve housing',
  'Arts and Culture': 'achieve positive arts- or cultural-engagement outcomes',
  'Basic Needs': 'meet basic needs',
  'Civic Engagement, Advocacy, and Systems Change': 'improve civic wellbeing',
  'Community and Neighborhood Revitalization': 'improve community wellbeing',
  'Community and School-Based Meal Programs': 'improve food security',
  'Community Economic Development': 'improve economic conditions',
  'Community Resiliency': 'improve community resiliency',
  'Disaster Preparation': 'prepare for disaster',
  'Disaster Response': 'recover from disaster ',
  'Diversity, Equity, Inclusion, and Accessibility':
    'increase inclusion and access',
  'Early Childhood Development': 'meet developmental milestones',
  'Economic Security': 'improve economic security',
  'Education: K-12 Classroom': 'improve educational outcomes',
  'Education: Out-of-School Programming': 'improve educational outcomes',
  'Education: Post-secondary, Career Development':
    'improve educational outcomes',
  'Educational Access': 'improve educational outcomes',
  'Educator Training': 'improve student achievement',
  'Emergency Housing': 'improve housing',
  'Environmental Conservation': 'protect the environment',
  'Food Distribution': 'improve food security',
  'Gender Equity': 'gain gender equity',
  'Growing and Harvesting': 'improve food security',
  Health: 'improve health',
  'Health Education and Behavior Change': 'improve health',
  'Health Systems, Policy, Advocacy, and Research': 'improve health',
  'Human Rights': 'protect human rights',
  'Positive Youth Development': 'improve youth development',
  'Public Safety': 'improve safety',
  'Racial Justice': 'empower themselves',
  'Recreation and Play': 'improve health',
  'Recycling and Waste': 'protect the environment',
  'Scholarships and Fellowships': 'improve educational outcomes',
  'Small Business and Non-Profit Support':
    'increase business or nonprofit success',
  'STEM Education: K-12 Classroom': 'improve STEM educational outcomes',
  'STEM Education: Out-of-School Programming':
    'improve STEM educational outcomes',
  'STEM Education: Post-secondary, Career Development':
    'improve STEM career development',
  'Sustainable Agriculture': 'protect the environment',
  'Sustainable Business Practices': 'protect the environment',
  'Transit and Mobility': 'increase access to transit and mobility options',
  'Water Access, Sanitation, and Hygiene': 'improve health',
  'Wildlife Conservation': 'improve animal welfare',
  'Workforce Development': 'improve employment',
};
